export default "__VITE_ASSET__b7a3f889__"